export default "__VITE_ASSET__ngu3D2Ul__"